import dayjs from '../utils/dayjsConfig'

export const getTimestampFromDateTime = (date) => {
  const d = new Date(date)
  return d.toLocaleString()
}

export const getCurrentDate = () => new Date().getFullYear() + '-' + getMonth() + '-' + getDay()

export const getMonth = () => {
  const m = new Date().getMonth() + 1
  if (m < 10) {
    return '0' + m
  } else {
    return m
  }
}

export const getDay = () => {
  const d = new Date().getDate()
  if (d < 10) {
    return '0' + d
  } else {
    return d
  }
}

export const getStartDate = () => {
  if (window.location.href.indexOf('start_date') >= 0) {
    const startDate = window.location.href.split('start_date=')
    return startDate[startDate.length - 1].split('&')[0]
  } else {
    return getCurrentDate()
  }
}

export const getFirstOfMonth = () => {
  return dayjs().startOf('month')
}

export const getEndDate = () => {
  if (window.location.href.indexOf('end_date') >= 0) {
    const endDay = window.location.href.split('end_date=')
    return endDay[endDay.length - 1].split('&')[0]
  } else {
    return getCurrentDate()
  }
}

export const fixDateString = (strDate) => {
  if (strDate) return strDate.replaceAll(/-/g, '/')
  return null
}

export const getCurrentLocalDate = () => {
  return dayjs().format('YYYY-MM-DD')
}

export const isValidDateFormat = (dateStr) => {
  return dayjs(dateStr, 'YYYY-MM-DD', true).isValid()
}

export const isDateInFuture = (dateStr) => {
  return dayjs(dateStr).isAfter(dayjs(), 'day')
}

export const isStartDateAfterEndDate = (startDate, endDate) => {
  return dayjs(startDate).isAfter(dayjs(endDate), 'day')
}

export const getMonthsDifference = (startDate, endDate) => {
  return dayjs(endDate).diff(dayjs(startDate), 'months')
}

export const validateDateRange = (startDate, endDate) => {
  const result = {
    invalidRangeOffset: false,
    invalidRangeLimit: false,
    invalidRangeFormat: false,
    invalidDateFormat: false,
    isValid: true
  }

  if (!isValidDateFormat(startDate) || !isValidDateFormat(endDate)) {
    result.invalidDateFormat = true
    result.isValid = false
    return result
  }

  if (isDateInFuture(startDate) || isDateInFuture(endDate)) {
    result.invalidRangeOffset = true
    result.isValid = false
  }

  if (isStartDateAfterEndDate(startDate, endDate)) {
    result.invalidRangeFormat = true
    result.isValid = false
  }

  if (dayjs(endDate).isAfter(dayjs(startDate).add(12, 'month'), 'day')) {
    result.invalidRangeLimit = true
    result.isValid = false
  }

  return result
}

export const getDateOnly = (date) => {
  return date ? dayjs(date).format('DD/MM/YYYY') : ''
}

export const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const formatTime = (time) => {
  const date = new Date(time)
  return date.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit', hour12: true })
}

export const formatDateTimeFull = (date) => {
  if (!date) return '-'
  return dayjs(date).format('DD-MM-YYYY, HH:mm:ss')
}
